import { render, staticRenderFns } from "./page_not_found.vue?vue&type=template&id=791ecbcd&scoped=true&"
import script from "./page_not_found.vue?vue&type=script&lang=js&"
export * from "./page_not_found.vue?vue&type=script&lang=js&"
import style0 from "./page_not_found.vue?vue&type=style&index=0&id=791ecbcd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791ecbcd",
  null
  
)

export default component.exports